
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class PsVatRefundPrintingParaDialog extends Serenity.EntityDialog<PsVatRefundPrintingParaRow, any> {
        protected getFormKey() { return PsVatRefundPrintingParaForm.formKey; }
        protected getIdProperty() { return PsVatRefundPrintingParaRow.idProperty; }
        protected getLocalTextPrefix() { return PsVatRefundPrintingParaRow.localTextPrefix; }
        protected getNameProperty() { return PsVatRefundPrintingParaRow.nameProperty; }
        protected getService() { return PsVatRefundPrintingParaService.baseUrl; }
        protected getDeletePermission() { return PsVatRefundPrintingParaRow.deletePermission; }
        protected getInsertPermission() { return PsVatRefundPrintingParaRow.insertPermission; }
        protected getUpdatePermission() { return PsVatRefundPrintingParaRow.updatePermission; }

        protected form = new PsVatRefundPrintingParaForm(this.idPrefix);

        constructor() {
            super();
        }
            protected afterLoadEntity() {
                super.afterLoadEntity();
        
        if (this.entity.FromCode == "Default") {
            this.saveAndCloseButton.toggleClass('disabled', true);
            this.applyChangesButton.toggleClass('disabled', true);
            this.deleteButton.toggleClass('disabled', true);
        }
    }

    }
}